import $ from 'jquery';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import Omnibox from 'omnibox/Omnibox';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class OmniboxErrorBoundary extends React.Component<{children: React.ReactNode}, {hasError: boolean}> {
  override state: {hasError: boolean} = {hasError: false};
  static getDerivedStateFromError(): {hasError: boolean} {
    return {hasError: true};
  }
  override componentDidCatch(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('Omnibox crashed:', error);
  }
  override render(): React.ReactNode {
    return this.state.hasError ? null : this.props.children;
  }
}

export function GatedOmnibox(): JSX.Element | null {
  const {llmEnableOmnibox} = useRolloutFlags();
  // The omnibox is on when either the LLM_ENABLE_OMNIBOX rollout flag or the SEARCH_ENABLE_QUICK_SEARCH
  // tenant config is on. When both are off the omnibox never mounts, so neither the Cmd+/ shortcut
  // nor the navbar search icon can surface it.
  if (!llmEnableOmnibox && !BenchlingConfig.SEARCH_ENABLE_QUICK_SEARCH) {
    return null;
  }
  return <Omnibox />;
}

export function init(): void {
  const $container = $('<div>').addClass('omnibox-container');
  $('body').append($container);
  renderToDOM(
    <OmniboxErrorBoundary>
      <GatedOmnibox />
    </OmniboxErrorBoundary>,
    $container[0]
  );
}
